import {HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AdminService} from '../services/admin.service';
import {UserService} from '../services/user.service';
import {UserGroupResponse} from './report-datepicker.types';
import {ReportDatepickerUiGateway} from './report-datepicker-ui.gateway';

@Injectable()
export class ReportDatepickerDepartmentLoader {
  constructor(
    private userService: UserService,
    private adminService: AdminService,
    private ui: ReportDatepickerUiGateway
  ) {
  }

  load(userId: string): void {
    this.userService.getUserFromAPI(userId).subscribe(
      (response: HttpResponse<Object>) => {
        const user = response.body as UserGroupResponse;
        this.adminService.getGroupByID(user.mainGroup).subscribe(
          (groupResponse: HttpResponse<Object>) =>
            this.ui.storeDepartment(groupResponse.body),
          () => undefined
        );
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/report-datepicker-department.loader.ts